<template>
  <div class="fullHeight">
    <div class="mainContainer">
      <div v-if="viewState === 'loading'" class="fullHeight">
    
        <v-col cols="12">
          <v-skeleton-loader
            v-for="item in 1"
            :key="item"
            v-bind="attrs"
            type="card-avatar, article"
          ></v-skeleton-loader>
        </v-col>
      </div>
      <div ref="publications" v-if="viewState === 'publications'">
        <div class="publications-wrapper">
          <div ref="publicationList" v-scroll="handleScroll">
            <publication-list
              ref="publicationItem"
              v-for="(subscribe, index) in postsData"
              :key="`${subscribe.key}-${index}`"
              :index="index"
              :source="subscribe"
              :showLast="showLast"
              :isSingle="false"
            />
          </div>
        </div>
      </div>
      <div>
        <div class="circle-loader" v-if="viewState === 'publications'"></div>
      </div>
      <div v-if="viewState === 'no-publications'" class="emptyPosts">
        <img
          :src="require('@/assets/img/noPosts.png')"
          class="emptyContentImg"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Publication from '@/components/publication/index'
import { mapGetters, mapActions } from 'vuex'
import { _ } from 'vue-underscore'

export default {
  name: 'Home',
  beforeMount: function () {
    this.next()
    this.notifications()
    this.addUser()
  },
  data () {
    return {
      subscribers: [],
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2
      },
      showLast: false,
      miLista: [],
      noPostSize: screen.width,
      startFirstLoad: false,
      lastScrollLimit: 0
    }
  },
  computed: {
    ...mapGetters(['getPostsData', 'getPostsRefs']),
    postsData () {
      return _.compact(this.getPostsData)
    },
    postsRefs () {
      return this.getPostsRefs
    },
    finishFirstLoad () {
      return _.isEmpty(this.postsData) === _.isEmpty(this.postsRefs)
    },
    loading () {
      return !this.startFirstLoad || !this.finishFirstLoad
    },
    hasContent () {
      return !_.isEmpty(this.postsData)
    },
    viewState () {
      let viewState = false
      if (!viewState && this.loading) viewState = 'loading'
      if (!viewState && this.hasContent) viewState = 'publications'
      if (!viewState && !this.hasContent) viewState = 'no-publications'
      return viewState
    }
  },
  components: {
    'publication-list': Publication
  },
  methods: {
    ...mapActions({
      nextPageAction: 'GET_NEXT_POSTS',
      notifications: 'GET_NEXT_NOTIFS',
      addUser: 'ADD_USER'
    }),
    next () {
      this.nextPageAction().then(this.nextFinished)
    },
    nextFinished () {
      this.startFirstLoad = true
    },
    handleScroll () {
      const scrollPos = window.scrollY + window.innerHeight
      const scrollLimit = this.$refs.publications.offsetHeight
      if (
        scrollLimit > this.lastScrollLimit &&
        scrollPos > scrollLimit - 5 * window.innerHeight
      ) {
        this.next()
        this.lastScrollLimit = scrollLimit
      }
      this.showLast = scrollPos > scrollLimit - 250
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Posts.vue